<template>
  <SplitContainer3 style="height:100%" :layout="12">
    <template #main>
      <div style="height:100%">
        <TableMain ref="SalesQuoteTable1" name="myName" :fields="fields" :title="table_title.title1"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
          :show_toolbar="true" :show_filter="true" :selectable="true" :isBusy="isBusy_table1" @on_query="on_query"
          @state_change="state_change" :show_toolbar_button="[0, 0, 1, 1, 1]" @tool_invoke="tool_invoke"
          @current_changed="current_changed" tableref="a871a46c984a4d2f9314adc1c9ea8c82">
          <template #query>
            物料编号：<el-input size="small" style="width: 120px" clearable v-model="InventCode"></el-input>
          </template>
        </TableMain>
      </div>
    </template>
    <template #top>
      <TableMain ref="SalesQuoteTable2" :show_query_container="true" :show_date_picker="false"
        :fields="inventTable_fields" :table_height_adjust="-8" :title="table_title.title2"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false" :pager_count="5"
        :isBusy="isBusy_table2" @on_query="SalesQuoteTable2_query" tableref="00440cd9a98c4d5ebe6392543b7cd46d">
        <template #query>
          物料编号：<el-input size="small" style="width: 120px" clearable v-model="InventCode_Item"></el-input>
        </template>
        <template #operation>
          <el-button type="info" plain class="ml-2" @click="SalesQuoteTable2_Cell_Chose"><i
              class="iconfont icon-down2"></i>&nbsp;&nbsp;{{ $t("common.selected") }}
          </el-button>
        </template>
      </TableMain>
    </template>
    <template #bottom>
      <TableMain ref="SalesQuoteTable3" :fields="item_fields" :show_query_container="false" :title="table_title.title3"
        :date_picker_label="date_picker_label" :table_height_adjust="2" :show_filter="false"
        :show_pagination="show_pagination" :pager_count="5" @state_change="state_change_table3"
        tableref="b6a61809ec634650aae201ac7b4fb0ce">
        <template #toolbar="">
          <el-tooltip content="导入" placement="top" effect="light">
            <el-button type="info" plain style="width: 55px" class="ml-2"><i
                class="iconfont icon-export-in"></i></el-button>
          </el-tooltip>
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
            @on_query="SalesQuoteTable3_Save" :label="$t('common.save')" class="ml-2"></QueryButton>
        </template>
      </TableMain>
    </template>
  </SplitContainer3>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
import TableDetail from "../components/table/TableDetail"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import SplitContainer3 from "../components/container/SplitContainer3"
import SplitContainer2 from "../components/container/SplitContainer2"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as SOSalesQuoteController from "../../controllers/sd/SOSalesQuoteController"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"

export default {
  name: "SOSalesQuote",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer3,
    SplitContainer2,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "销售报价列表",
        title2: "物料列表",
        title3: "销售报价详情",
      },
      InventCode: "",
      InventCode_Item: "",
      fields: SOSalesQuoteController.fields.default,
      item_fields: SOSalesQuoteController.fields.item_fields,
      inventTable_fields: SOSalesQuoteController.fields.inventTable_fields,
      dataForm: _.cloneDeep(SOSalesQuoteController.dataForm),
      isBusy_table1: false,
      isBusy_table2: false,
      show_pagination: false,
    }
  },
  created() {
    let _Currencys = this.$store.state.biz_data.baseData.Currency
    let _field = _.find(this.item_fields, { key: "CurrencyCode" })
    _field["_options"] = {
      provider: (v) => {
        return _.map(_Currencys, (v) => {
          return { value: v.CurrencyCode, label: v.Txt }
        })
      },
    }

    // this.$store.state.biz_data.baseData.Currency
  },
  activated() { },
  deactivated() { },
  computed: {},

  methods: {
    //#region Table1
    ///查询
    async on_query(set_data) {
      this.isBusy_table1 = true
      let _params = { id: { ">": 0 } }
      if (this.CustAcInventCodecount != "") {
        _params.SEI_InventTable_ItemId = { "=": this.InventCode }
      }
      let _result = await SOSalesQuoteController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]))
        // this.$refs.SalesQuoteTable3.SetData([])
      }
      this.isBusy_table1 = false
    },
    ///状态切换
    state_change(data, cb) {
      if (data && data.state === "deleted") {
        if (data.selected_items.length > 0) {
          this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
            if (v) {
              let result = await SOSalesQuoteController.methods.deleteData(
                data.selected_items
              )
              if (result) {
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
              }
            }
          })
        }
      } else if (data.state === "approved" || data.state === "unapproved") {
        let _msg = data.state == "approved" ? "审批" : "反审"
        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            let _list = _.cloneDeep(data.selected_items)
            _.each(_list, (t) => {
              t.is_approved = data.state == "approved" ? true : false
            })
            let result = await SOSalesQuoteController.methods.approveData(
              _list
            )
            if (result) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'SOSalesQuote', data, this)
              cb(true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
          else {
            await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, 'SOSalesQuote', data, this)
          }
        })
      }
    },
    ///export and import
    tool_invoke(data) { },
    ///row click
    current_changed(old, current) {
      let new_items = []
      let _t = _.cloneDeep(this.dataForm)
      for (var i in _t) {
        _t[i] = current[i]
      }
      new_items.push(_.cloneDeep(_t))
      this.$refs.SalesQuoteTable3.SetData(new_items)
    },
    //#endregion

    //#region Table2
    ///查询物料
    async SalesQuoteTable2_query(set_data) {
      this.isBusy_table2 = true
      let _params = { id: { "<": 1000 } }
      if (this.InventCode_Item != "") {
        _params.ItemId = { "=": this.InventCode_Item }
      }
      let _result = await InventTableController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["asc"]))
      }
      this.isBusy_table2 = false
    },
    ///物料选择
    SalesQuoteTable2_Cell_Chose() {
      let _this = this
      let _invent_select_items = this.$refs.SalesQuoteTable2.GetSelectedItems()
      if (_invent_select_items && _invent_select_items.length > 0) {
        let _dt = []
        _.each(_.cloneDeep(_invent_select_items), (t) => {
          let _item = _.cloneDeep(_this.dataForm)
          _item.id = ""
          _item.SEI_InventTable_ItemId = t.ItemId
          _item.AccountCode = t.TEC_CustAccount
          _item.FromDate = new Date()
          _item.ToDate = new Date()
          _dt.push(_item)
        })
        this.$refs.SalesQuoteTable3.AppendItems(_dt)
        let table3_dt = this.$refs.SalesQuoteTable3.my_data
        if (table3_dt && table3_dt.length > 50) {
          this.show_pagination = true
        }

        this.$refs.SalesQuoteTable2.UnSelectAll()
      }
    },
    //#endregion

    //#region Table3
    ///保存
    async SalesQuoteTable3_Save(cb) {
      if (this.Table3_Check_Save()) {
        let _items = []
        _.each(this.$refs.SalesQuoteTable3.my_data, (t) => {
          let _data = _.cloneDeep(this.dataForm)
          for (var i in _data) {
            _data[i] = t[i]
          }

          if (_.isDate(_data.FromDate)) {
            _data.FromDate = this.$date.format(
              _data.FromDate,
              "yyyy-MM-dd HH:mm:ss"
            )
          }
          if (_.isDate(_data.ToDate)) {
            _data.ToDate = this.$date.format(
              _data.ToDate,
              "yyyy-MM-dd HH:mm:ss"
            )
          }

          _items.push(_data)
        })
        console.log(_items)
        ///保存数据
        let _rel_save_data = await SOSalesQuoteController.methods.saveSalesQuoteItems(
          _items
        )
        cb()
        if (!_.isNull(_rel_save_data)) {
          ///成功
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          let _list = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/i/") > -1
          })

          //新增
          let _items = []
          if (_list && _list.length > 0) {
            _.each(_list, (t) => {
              _items = _.union(_items, t.Result.Data[0])
            })
            this.$refs.SalesQuoteTable1.InsertItems(
              _.orderBy(_items, ["id"], ["desc"])
            )
            this.$refs.SalesQuoteTable3.SetData([])
          }

          //修改
          let _update_list = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/u/") > -1
          })
          if (_update_list && _update_list.length > 0) {
            _.each(_update_list, (t) => {
              let _ul = t.Result.Data[0]
              _.each(_ul, (m) => {
                this.$refs.SalesQuoteTable1.UpdateItems({ id: m.id }, m)
              })
            })
          }
        } else {
          ///失败
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      }
    },
    Table3_Check_Save() {
      return true
    },
    ///状态切换
    state_change_table3(data, cb) {
      if (data && data.state === "deleted") {
        this.msgModal("此删除仅清除当前列表选中数据，确定要继续吗？").then(
          async (v) => {
            if (v) {
              if (data.selected_items.length > 0) {
                cb(true)
                let table3_dt = this.$refs.SalesQuoteTable3.my_data
                if (table3_dt && table3_dt.length <= 50) {
                  this.show_pagination = false
                }
              }
            }
          }
        )
      }
    },
    //#endregion
  },
}
</script>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
